const SERVER_URL = process.env.SERVER_URL || 'https://jet.style'

export const API_URL = `${SERVER_URL}/api`;



// WEBPACK FOOTER //
// ./src/constants/config.js